import { render, staticRenderFns } from "./TeacherPreview.vue?vue&type=template&id=c31a13c8&scoped=true&"
import script from "./TeacherPreview.vue?vue&type=script&lang=js&"
export * from "./TeacherPreview.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPreview.vue?vue&type=style&index=0&id=c31a13c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31a13c8",
  null
  
)

export default component.exports